// @ts-nocheck
'use client'
/* THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */
/* Instructions on how to add an icon for the Icon component can be found in README.md */

import dynamic from 'next/dynamic'

type IconProps = { className?: string; role?: string }

const AIIcon = dynamic<IconProps>(() => import('../svg/aI.svg'))
const AiNodesIcon = dynamic<IconProps>(() => import('../svg/ai-nodes.svg'))
const AirplaneIcon = dynamic<IconProps>(() => import('../svg/airplane.svg'))
const ArrowDownSmallIcon = dynamic<IconProps>(() => import('../svg/arrow-down-small.svg'))
const ArrowDownIcon = dynamic<IconProps>(() => import('../svg/arrow-down.svg'))
const ArrowLeftCornerIcon = dynamic<IconProps>(() => import('../svg/arrow-left-corner.svg'))
const ArrowLeftSmallIcon = dynamic<IconProps>(() => import('../svg/arrow-left-small.svg'))
const ArrowLeftIcon = dynamic<IconProps>(() => import('../svg/arrow-left.svg'))
const ArrowRightCornerIcon = dynamic<IconProps>(() => import('../svg/arrow-right-corner.svg'))
const ArrowRightSmallIcon = dynamic<IconProps>(() => import('../svg/arrow-right-small.svg'))
const ArrowRightIcon = dynamic<IconProps>(() => import('../svg/arrow-right.svg'))
const ArrowUpSmallIcon = dynamic<IconProps>(() => import('../svg/arrow-up-small.svg'))
const ArrowUpIcon = dynamic<IconProps>(() => import('../svg/arrow-up.svg'))
const ArrowsIcon = dynamic<IconProps>(() => import('../svg/arrows.svg'))
const AvailabilityIcon = dynamic<IconProps>(() => import('../svg/availability.svg'))
const AwardsIcon = dynamic<IconProps>(() => import('../svg/awards.svg'))
const BadgeEmployeeIcon = dynamic<IconProps>(() => import('../svg/badge-employee.svg'))
const BagIcon = dynamic<IconProps>(() => import('../svg/bag.svg'))
const BargainIcon = dynamic<IconProps>(() => import('../svg/bargain.svg'))
const BellIcon = dynamic<IconProps>(() => import('../svg/bell.svg'))
const ButtonClick2Icon = dynamic<IconProps>(() => import('../svg/button-click-2.svg'))
const ButtonClickIcon = dynamic<IconProps>(() => import('../svg/button-click.svg'))
const CalendarCheckIcon = dynamic<IconProps>(() => import('../svg/calendar-check.svg'))
const CalendarIcon = dynamic<IconProps>(() => import('../svg/calendar.svg'))
const CarrotIcon = dynamic<IconProps>(() => import('../svg/carrot.svg'))
const CartClockIcon = dynamic<IconProps>(() => import('../svg/cart-clock.svg'))
const CheckBoxIcon = dynamic<IconProps>(() => import('../svg/check-box.svg'))
const CheckIcon = dynamic<IconProps>(() => import('../svg/check.svg'))
const CircleIcon = dynamic<IconProps>(() => import('../svg/circle.svg'))
const ClockIcon = dynamic<IconProps>(() => import('../svg/clock.svg'))
const Close2Icon = dynamic<IconProps>(() => import('../svg/close-2.svg'))
const CloseIcon = dynamic<IconProps>(() => import('../svg/close.svg'))
const Cloud2Icon = dynamic<IconProps>(() => import('../svg/cloud-2.svg'))
const CloudSafeIcon = dynamic<IconProps>(() => import('../svg/cloud-safe.svg'))
const CloudsDownloadIcon = dynamic<IconProps>(() => import('../svg/clouds-download.svg'))
const CloudsUploadIcon = dynamic<IconProps>(() => import('../svg/clouds-upload.svg'))
const CoWorkingIcon = dynamic<IconProps>(() => import('../svg/co-working.svg'))
const CodeIcon = dynamic<IconProps>(() => import('../svg/code.svg'))
const CoffeeIcon = dynamic<IconProps>(() => import('../svg/coffee.svg'))
const CompactIcon = dynamic<IconProps>(() => import('../svg/compact.svg'))
const CompareIcon = dynamic<IconProps>(() => import('../svg/compare.svg'))
const ComputerIcon = dynamic<IconProps>(() => import('../svg/computer.svg'))
const ConnectNetworkIcon = dynamic<IconProps>(() => import('../svg/connect-network.svg'))
const ContactUserIcon = dynamic<IconProps>(() => import('../svg/contact-user.svg'))
const ContactIcon = dynamic<IconProps>(() => import('../svg/contact.svg'))
const ConversationIcon = dynamic<IconProps>(() => import('../svg/conversation.svg'))
const CreditCardIcon = dynamic<IconProps>(() => import('../svg/credit-card.svg'))
const Delivery2Icon = dynamic<IconProps>(() => import('../svg/delivery-2.svg'))
const DeliveryIcon = dynamic<IconProps>(() => import('../svg/delivery.svg'))
const DeskIcon = dynamic<IconProps>(() => import('../svg/desk.svg'))
const DiplomaIcon = dynamic<IconProps>(() => import('../svg/diploma.svg'))
const DisasterRecoveryIcon = dynamic<IconProps>(() => import('../svg/disaster-recovery.svg'))
const DocIcon = dynamic<IconProps>(() => import('../svg/doc.svg'))
const DocsIcon = dynamic<IconProps>(() => import('../svg/docs.svg'))
const DocumentCheckIcon = dynamic<IconProps>(() => import('../svg/document-check.svg'))
const DocumentLicenseIcon = dynamic<IconProps>(() => import('../svg/document-license.svg'))
const DownloadIcon = dynamic<IconProps>(() => import('../svg/download.svg'))
const DustinHomeLogoIcon = dynamic<IconProps>(() => import('../svg/dustin-home-logo.svg'))
const DustinLogoIcon = dynamic<IconProps>(() => import('../svg/dustin-logo.svg'))
const DustinSymbolInnerIcon = dynamic<IconProps>(() => import('../svg/dustin-symbol-inner.svg'))
const DustinSymbolOuterIcon = dynamic<IconProps>(() => import('../svg/dustin-symbol-outer.svg'))
const DustinSymbolIcon = dynamic<IconProps>(() => import('../svg/dustin-symbol.svg'))
const EasyWorkplaceIcon = dynamic<IconProps>(() => import('../svg/easy-workplace.svg'))
const EducationIcon = dynamic<IconProps>(() => import('../svg/education.svg'))
const EmailRecieveIcon = dynamic<IconProps>(() => import('../svg/email-recieve.svg'))
const EmailSendIcon = dynamic<IconProps>(() => import('../svg/email-send.svg'))
const EmailIcon = dynamic<IconProps>(() => import('../svg/email.svg'))
const EqualityIcon = dynamic<IconProps>(() => import('../svg/equality.svg'))
const EvaluationIcon = dynamic<IconProps>(() => import('../svg/evaluation.svg'))
const EventMicroIcon = dynamic<IconProps>(() => import('../svg/event-micro.svg'))
const FabricIcon = dynamic<IconProps>(() => import('../svg/fabric.svg'))
const FolderIcon = dynamic<IconProps>(() => import('../svg/folder.svg'))
const FoodIcon = dynamic<IconProps>(() => import('../svg/food.svg'))
const GalleryIcon = dynamic<IconProps>(() => import('../svg/gallery.svg'))
const GamingIcon = dynamic<IconProps>(() => import('../svg/gaming.svg'))
const GiftIcon = dynamic<IconProps>(() => import('../svg/gift.svg'))
const GlobenIcon = dynamic<IconProps>(() => import('../svg/globen.svg'))
const GovernanceDocIcon = dynamic<IconProps>(() => import('../svg/governance-doc.svg'))
const GraphIcon = dynamic<IconProps>(() => import('../svg/graph.svg'))
const HamburgerIcon = dynamic<IconProps>(() => import('../svg/hamburger.svg'))
const HeadphonesIcon = dynamic<IconProps>(() => import('../svg/headphones.svg'))
const HeadsetIcon = dynamic<IconProps>(() => import('../svg/headset.svg'))
const HeartSolidIcon = dynamic<IconProps>(() => import('../svg/heart-solid.svg'))
const HeartIcon = dynamic<IconProps>(() => import('../svg/heart.svg'))
const HomeIcon = dynamic<IconProps>(() => import('../svg/home.svg'))
const IdeaIcon = dynamic<IconProps>(() => import('../svg/idea.svg'))
const ImageIcon = dynamic<IconProps>(() => import('../svg/image.svg'))
const InfoAttentionIcon = dynamic<IconProps>(() => import('../svg/info-attention.svg'))
const InfoIcon = dynamic<IconProps>(() => import('../svg/info.svg'))
const ItIcon = dynamic<IconProps>(() => import('../svg/it.svg'))
const KeyIcon = dynamic<IconProps>(() => import('../svg/key.svg'))
const KitchenIcon = dynamic<IconProps>(() => import('../svg/kitchen.svg'))
const KnowledgeIcon = dynamic<IconProps>(() => import('../svg/knowledge.svg'))
const LabelIcon = dynamic<IconProps>(() => import('../svg/label.svg'))
const LaptopIcon = dynamic<IconProps>(() => import('../svg/laptop.svg'))
const LeafIcon = dynamic<IconProps>(() => import('../svg/leaf.svg'))
const ListIcon = dynamic<IconProps>(() => import('../svg/list.svg'))
const LocationIcon = dynamic<IconProps>(() => import('../svg/location.svg'))
const LogInIcon = dynamic<IconProps>(() => import('../svg/log-in.svg'))
const LogOutIcon = dynamic<IconProps>(() => import('../svg/log-out.svg'))
const LoungeZoneIcon = dynamic<IconProps>(() => import('../svg/lounge-zone.svg'))
const ManWomanIcon = dynamic<IconProps>(() => import('../svg/man-woman.svg'))
const MarketIcon = dynamic<IconProps>(() => import('../svg/market.svg'))
const Meeting2Icon = dynamic<IconProps>(() => import('../svg/meeting-2.svg'))
const MeetingIcon = dynamic<IconProps>(() => import('../svg/meeting.svg'))
const MeetingsIcon = dynamic<IconProps>(() => import('../svg/meetings.svg'))
const MegaphoneIcon = dynamic<IconProps>(() => import('../svg/megaphone.svg'))
const Microsoft365Icon = dynamic<IconProps>(() => import('../svg/microsoft-365.svg'))
const MinusIcon = dynamic<IconProps>(() => import('../svg/minus.svg'))
const MouseIcon = dynamic<IconProps>(() => import('../svg/mouse.svg'))
const NetworkWifi2Icon = dynamic<IconProps>(() => import('../svg/network-wifi-2.svg'))
const NetworkWifiIcon = dynamic<IconProps>(() => import('../svg/network-wifi.svg'))
const NetworkIcon = dynamic<IconProps>(() => import('../svg/network.svg'))
const NeutralThumbIcon = dynamic<IconProps>(() => import('../svg/neutral-thumb.svg'))
const Office2Icon = dynamic<IconProps>(() => import('../svg/office-2.svg'))
const Office3Icon = dynamic<IconProps>(() => import('../svg/office-3.svg'))
const Office4Icon = dynamic<IconProps>(() => import('../svg/office-4.svg'))
const OfficeIcon = dynamic<IconProps>(() => import('../svg/office.svg'))
const PenIcon = dynamic<IconProps>(() => import('../svg/pen.svg'))
const PhoneIcon = dynamic<IconProps>(() => import('../svg/phone.svg'))
const PlusIcon = dynamic<IconProps>(() => import('../svg/plus.svg'))
const PopoverArrowIcon = dynamic<IconProps>(() => import('../svg/popover-arrow.svg'))
const PopoverEdgeArrowIcon = dynamic<IconProps>(() => import('../svg/popover-edge-arrow.svg'))
const PresentationIcon = dynamic<IconProps>(() => import('../svg/presentation.svg'))
const PrinterIcon = dynamic<IconProps>(() => import('../svg/printer.svg'))
const QuestionIcon = dynamic<IconProps>(() => import('../svg/question.svg'))
const ReportDocIcon = dynamic<IconProps>(() => import('../svg/report-doc.svg'))
const ReportNumbersIcon = dynamic<IconProps>(() => import('../svg/report-numbers.svg'))
const ReportStatsIcon = dynamic<IconProps>(() => import('../svg/report-stats.svg'))
const RobotIcon = dynamic<IconProps>(() => import('../svg/robot.svg'))
const SadDislikeFaceIcon = dynamic<IconProps>(() => import('../svg/sad-dislike-face.svg'))
const ScreenIcon = dynamic<IconProps>(() => import('../svg/screen.svg'))
const SearchIcon = dynamic<IconProps>(() => import('../svg/search.svg'))
const Security2Icon = dynamic<IconProps>(() => import('../svg/security-2.svg'))
const SecurityIcon = dynamic<IconProps>(() => import('../svg/security.svg'))
const SeminarMicro2Icon = dynamic<IconProps>(() => import('../svg/seminar-micro-2.svg'))
const SeminarMicroIcon = dynamic<IconProps>(() => import('../svg/seminar-micro.svg'))
const ServerIcon = dynamic<IconProps>(() => import('../svg/server.svg'))
const ServiceIcon = dynamic<IconProps>(() => import('../svg/service.svg'))
const ServicesIcon = dynamic<IconProps>(() => import('../svg/services.svg'))
const SettingsIcon = dynamic<IconProps>(() => import('../svg/settings.svg'))
const ShareIcon = dynamic<IconProps>(() => import('../svg/share.svg'))
const ShoppingCart2Icon = dynamic<IconProps>(() => import('../svg/shopping-cart-2.svg'))
const ShoppingCart3Icon = dynamic<IconProps>(() => import('../svg/shopping-cart-3.svg'))
const ShoppingCart4Icon = dynamic<IconProps>(() => import('../svg/shopping-cart-4.svg'))
const ShoppingCart5Icon = dynamic<IconProps>(() => import('../svg/shopping-cart-5.svg'))
const ShoppingCartIcon = dynamic<IconProps>(() => import('../svg/shopping-cart.svg'))
const SilentIcon = dynamic<IconProps>(() => import('../svg/silent.svg'))
const SkipLeftIcon = dynamic<IconProps>(() => import('../svg/skip-left.svg'))
const SkipRightIcon = dynamic<IconProps>(() => import('../svg/skip-right.svg'))
const SoundIcon = dynamic<IconProps>(() => import('../svg/sound.svg'))
const SpeechBubble2Icon = dynamic<IconProps>(() => import('../svg/speech-bubble-2.svg'))
const SpeechBubbleIcon = dynamic<IconProps>(() => import('../svg/speech-bubble.svg'))
const StarBlackGrayIcon = dynamic<IconProps>(() => import('../svg/star-black-gray.svg'))
const StarBlackIcon = dynamic<IconProps>(() => import('../svg/star-black.svg'))
const StarGrayIcon = dynamic<IconProps>(() => import('../svg/star-gray.svg'))
const StarIcon = dynamic<IconProps>(() => import('../svg/star.svg'))
const StationaryBoxIcon = dynamic<IconProps>(() => import('../svg/stationary-box.svg'))
const Statistic2Icon = dynamic<IconProps>(() => import('../svg/statistic-2.svg'))
const StatisticIcon = dynamic<IconProps>(() => import('../svg/statistic.svg'))
const StopIcon = dynamic<IconProps>(() => import('../svg/stop.svg'))
const StorageIcon = dynamic<IconProps>(() => import('../svg/storage.svg'))
const SustainabilityArrowsIcon = dynamic<IconProps>(
  () => import('../svg/sustainability-arrows.svg')
)
const SwitchAccountIcon = dynamic<IconProps>(() => import('../svg/switch-account.svg'))
const TakebackSafeboxIcon = dynamic<IconProps>(() => import('../svg/takeback-safebox.svg'))
const Tea1Icon = dynamic<IconProps>(() => import('../svg/tea-1.svg'))
const Tea2Icon = dynamic<IconProps>(() => import('../svg/tea-2.svg'))
const ThumbsDownIcon = dynamic<IconProps>(() => import('../svg/thumbs-down.svg'))
const ThumbsUpIcon = dynamic<IconProps>(() => import('../svg/thumbs-up.svg'))
const ThumbsIcon = dynamic<IconProps>(() => import('../svg/thumbs.svg'))
const TimeOngoingIcon = dynamic<IconProps>(() => import('../svg/time-ongoing.svg'))
const TomatoIcon = dynamic<IconProps>(() => import('../svg/tomato.svg'))
const TrashBinIcon = dynamic<IconProps>(() => import('../svg/trash-bin.svg'))
const TravelIcon = dynamic<IconProps>(() => import('../svg/travel.svg'))
const UmbrellaIcon = dynamic<IconProps>(() => import('../svg/umbrella.svg'))
const UploadIcon = dynamic<IconProps>(() => import('../svg/upload.svg'))
const UserMinusIcon = dynamic<IconProps>(() => import('../svg/user-minus.svg'))
const UserPlusIcon = dynamic<IconProps>(() => import('../svg/user-plus.svg'))
const UserIcon = dynamic<IconProps>(() => import('../svg/user.svg'))
const VideoElearningsIcon = dynamic<IconProps>(() => import('../svg/video-elearnings.svg'))
const VideoPlayButtonIcon = dynamic<IconProps>(() => import('../svg/video-play-button.svg'))
const WarningIcon = dynamic<IconProps>(() => import('../svg/warning.svg'))
const WeatherActivitetIcon = dynamic<IconProps>(() => import('../svg/weather-activitet.svg'))
const WorkplaceIcon = dynamic<IconProps>(() => import('../svg/workplace.svg'))
const ZoomInIcon = dynamic<IconProps>(() => import('../svg/zoom-in.svg'))
const ZoomOutIcon = dynamic<IconProps>(() => import('../svg/zoom-out.svg'))

export const icons = {
  aI: AIIcon,
  'ai-nodes': AiNodesIcon,
  airplane: AirplaneIcon,
  'arrow-down-small': ArrowDownSmallIcon,
  'arrow-down': ArrowDownIcon,
  'arrow-left-corner': ArrowLeftCornerIcon,
  'arrow-left-small': ArrowLeftSmallIcon,
  'arrow-left': ArrowLeftIcon,
  'arrow-right-corner': ArrowRightCornerIcon,
  'arrow-right-small': ArrowRightSmallIcon,
  'arrow-right': ArrowRightIcon,
  'arrow-up-small': ArrowUpSmallIcon,
  'arrow-up': ArrowUpIcon,
  arrows: ArrowsIcon,
  availability: AvailabilityIcon,
  awards: AwardsIcon,
  'badge-employee': BadgeEmployeeIcon,
  bag: BagIcon,
  bargain: BargainIcon,
  bell: BellIcon,
  'button-click-2': ButtonClick2Icon,
  'button-click': ButtonClickIcon,
  'calendar-check': CalendarCheckIcon,
  calendar: CalendarIcon,
  carrot: CarrotIcon,
  'cart-clock': CartClockIcon,
  'check-box': CheckBoxIcon,
  check: CheckIcon,
  circle: CircleIcon,
  clock: ClockIcon,
  'close-2': Close2Icon,
  close: CloseIcon,
  'cloud-2': Cloud2Icon,
  'cloud-safe': CloudSafeIcon,
  'clouds-download': CloudsDownloadIcon,
  'clouds-upload': CloudsUploadIcon,
  'co-working': CoWorkingIcon,
  code: CodeIcon,
  coffee: CoffeeIcon,
  compact: CompactIcon,
  compare: CompareIcon,
  computer: ComputerIcon,
  'connect-network': ConnectNetworkIcon,
  'contact-user': ContactUserIcon,
  contact: ContactIcon,
  conversation: ConversationIcon,
  'credit-card': CreditCardIcon,
  'delivery-2': Delivery2Icon,
  delivery: DeliveryIcon,
  desk: DeskIcon,
  diploma: DiplomaIcon,
  'disaster-recovery': DisasterRecoveryIcon,
  doc: DocIcon,
  docs: DocsIcon,
  'document-check': DocumentCheckIcon,
  'document-license': DocumentLicenseIcon,
  download: DownloadIcon,
  'dustin-home-logo': DustinHomeLogoIcon,
  'dustin-logo': DustinLogoIcon,
  'dustin-symbol-inner': DustinSymbolInnerIcon,
  'dustin-symbol-outer': DustinSymbolOuterIcon,
  'dustin-symbol': DustinSymbolIcon,
  'easy-workplace': EasyWorkplaceIcon,
  education: EducationIcon,
  'email-recieve': EmailRecieveIcon,
  'email-send': EmailSendIcon,
  email: EmailIcon,
  equality: EqualityIcon,
  evaluation: EvaluationIcon,
  'event-micro': EventMicroIcon,
  fabric: FabricIcon,
  folder: FolderIcon,
  food: FoodIcon,
  gallery: GalleryIcon,
  gaming: GamingIcon,
  gift: GiftIcon,
  globen: GlobenIcon,
  'governance-doc': GovernanceDocIcon,
  graph: GraphIcon,
  hamburger: HamburgerIcon,
  headphones: HeadphonesIcon,
  headset: HeadsetIcon,
  'heart-solid': HeartSolidIcon,
  heart: HeartIcon,
  home: HomeIcon,
  idea: IdeaIcon,
  image: ImageIcon,
  'info-attention': InfoAttentionIcon,
  info: InfoIcon,
  it: ItIcon,
  key: KeyIcon,
  kitchen: KitchenIcon,
  knowledge: KnowledgeIcon,
  label: LabelIcon,
  laptop: LaptopIcon,
  leaf: LeafIcon,
  list: ListIcon,
  location: LocationIcon,
  'log-in': LogInIcon,
  'log-out': LogOutIcon,
  'lounge-zone': LoungeZoneIcon,
  'man-woman': ManWomanIcon,
  market: MarketIcon,
  'meeting-2': Meeting2Icon,
  meeting: MeetingIcon,
  meetings: MeetingsIcon,
  megaphone: MegaphoneIcon,
  'microsoft-365': Microsoft365Icon,
  minus: MinusIcon,
  mouse: MouseIcon,
  'network-wifi-2': NetworkWifi2Icon,
  'network-wifi': NetworkWifiIcon,
  network: NetworkIcon,
  'neutral-thumb': NeutralThumbIcon,
  'office-2': Office2Icon,
  'office-3': Office3Icon,
  'office-4': Office4Icon,
  office: OfficeIcon,
  pen: PenIcon,
  phone: PhoneIcon,
  plus: PlusIcon,
  'popover-arrow': PopoverArrowIcon,
  'popover-edge-arrow': PopoverEdgeArrowIcon,
  presentation: PresentationIcon,
  printer: PrinterIcon,
  question: QuestionIcon,
  'report-doc': ReportDocIcon,
  'report-numbers': ReportNumbersIcon,
  'report-stats': ReportStatsIcon,
  robot: RobotIcon,
  'sad-dislike-face': SadDislikeFaceIcon,
  screen: ScreenIcon,
  search: SearchIcon,
  'security-2': Security2Icon,
  security: SecurityIcon,
  'seminar-micro-2': SeminarMicro2Icon,
  'seminar-micro': SeminarMicroIcon,
  server: ServerIcon,
  service: ServiceIcon,
  services: ServicesIcon,
  settings: SettingsIcon,
  share: ShareIcon,
  'shopping-cart-2': ShoppingCart2Icon,
  'shopping-cart-3': ShoppingCart3Icon,
  'shopping-cart-4': ShoppingCart4Icon,
  'shopping-cart-5': ShoppingCart5Icon,
  'shopping-cart': ShoppingCartIcon,
  silent: SilentIcon,
  'skip-left': SkipLeftIcon,
  'skip-right': SkipRightIcon,
  sound: SoundIcon,
  'speech-bubble-2': SpeechBubble2Icon,
  'speech-bubble': SpeechBubbleIcon,
  'star-black-gray': StarBlackGrayIcon,
  'star-black': StarBlackIcon,
  'star-gray': StarGrayIcon,
  star: StarIcon,
  'stationary-box': StationaryBoxIcon,
  'statistic-2': Statistic2Icon,
  statistic: StatisticIcon,
  stop: StopIcon,
  storage: StorageIcon,
  'sustainability-arrows': SustainabilityArrowsIcon,
  'switch-account': SwitchAccountIcon,
  'takeback-safebox': TakebackSafeboxIcon,
  'tea-1': Tea1Icon,
  'tea-2': Tea2Icon,
  'thumbs-down': ThumbsDownIcon,
  'thumbs-up': ThumbsUpIcon,
  thumbs: ThumbsIcon,
  'time-ongoing': TimeOngoingIcon,
  tomato: TomatoIcon,
  'trash-bin': TrashBinIcon,
  travel: TravelIcon,
  umbrella: UmbrellaIcon,
  upload: UploadIcon,
  'user-minus': UserMinusIcon,
  'user-plus': UserPlusIcon,
  user: UserIcon,
  'video-elearnings': VideoElearningsIcon,
  'video-play-button': VideoPlayButtonIcon,
  warning: WarningIcon,
  'weather-activitet': WeatherActivitetIcon,
  workplace: WorkplaceIcon,
  'zoom-in': ZoomInIcon,
  'zoom-out': ZoomOutIcon,
}
